// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1PG69","row":"ProcedureTreatmentSummary_row__1xJjm"};